import { render, staticRenderFns } from "./CareQuestion.vue?vue&type=template&id=f47f062c"
import script from "./CareQuestion.vue?vue&type=script&lang=ts"
export * from "./CareQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports